import { useMemo, useState } from "react";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import AddTypeModal from "./AddTypeModal";
import RenderTable from "./renderTable";
import { Topic } from "../types";
import AddSkillsModal from "./AddSkillsModal";

const getInitialTopicsData = (topics): Topic[] => {
  return topics.topics.map(
    ({ topic, subtopic, isDSARelatedTopic, questionTypes }) => ({
      topic,
      subtopic,
      isDSARelatedTopic,
      questionTypes: questionTypes.map(
        ({
          questionType,
          difficultyLevel,
          numberOfQuestions,
          additionalFeedback,
        }) => ({
          questionType,
          difficultyLevel,
          numberOfQuestions,
          additionalFeedback: additionalFeedback || "",
        })
      ),
    })
  );
};

const calculateTotalQuestions = (topicsData: Topic[]): number => {
  return topicsData.reduce(
    (total, topic) =>
      total +
      topic.questionTypes.reduce(
        (subTotal, question) => subTotal + question.numberOfQuestions,
        0
      ),
    0
  );
};

const RenderGrid = ({ topics }) => {
  const [topicsData, setTopicsData] = useState<Topic[]>(() =>
    getInitialTopicsData(topics)
  );
  const [newQuestion, setNewQuestion] = useState({
    index: 0,
    questionType: STATIC_STRINGS.MCQ,
    difficultyLevel: STATIC_STRINGS.EASY,
    numberOfQuestions: 1,
    additionalFeedback: "",
  });
  const [isModalOpen, setModalOpen] = useState("");
  const [isSkillModalOpen, setSkillModalOpen] = useState("");

  const totalQuestions = useMemo(
    () => calculateTotalQuestions(topicsData),
    [topicsData]
  );

  return (
    <div className="w-full flex flex-col h-2/3 text-sm xl:text-base">
      <div className="flex justify-between items-center pb-2">
        <div className="flex">
          Total Questions :&nbsp;
          <div className="font-semibold mr-2">{totalQuestions}</div>
          {STATIC_STRINGS.ESTIMATED_ASSESSMENT_TIME}&nbsp;
          <div className="font-semibold">{topics.totalDuration / 60} Mins</div>
        </div>
        <button
          onClick={() => setSkillModalOpen("open")}
          className="btn btn-primary py-1 px-2"
        >
          {STATIC_STRINGS.ADD_SKILLS}
        </button>
      </div>
      <RenderTable
        topicsData={topicsData}
        setTopicsData={setTopicsData}
        setModalOpen={setModalOpen}
        setNewQuestion={setNewQuestion}
      />
      <AddTypeModal
        setTopicsData={setTopicsData}
        newQuestion={newQuestion}
        setNewQuestion={setNewQuestion}
        isModalOpen={isModalOpen}
        setModalOpen={setModalOpen}
      />
      <AddSkillsModal
        isModalOpen={isSkillModalOpen}
        setModalOpen={setSkillModalOpen}
      />
    </div>
  );
};

export default RenderGrid;
